import React from 'react';
import { ReferenceArrayInput, AutocompleteArrayInput } from 'react-admin';
import { getSelectedCompanyFilter } from '../../helper/filter';

export const CourseCategoriesInput = ({ formData }) => {
  const companyFilter = getSelectedCompanyFilter();

  const filterToQuery = (searchText) => ({
    'translations.name': searchText,
  });

  return (
    <ReferenceArrayInput
      source={'categories'}
      reference="categories"
      label="Categories"
      filter={companyFilter}
    >
      <AutocompleteArrayInput
        fullWidth
        optionText="labelView"
        debounce={500}
        filterToQuery={filterToQuery}
        id={'categories'}
      />
    </ReferenceArrayInput>
  );
};

export const CourseCodesInput = ({ formData }) => {
  const companyFilter = getSelectedCompanyFilter();

  const filterToQuery = (searchText) => ({
    'code': searchText,
  });

  return (
      <ReferenceArrayInput
          source="reviewCourses"
          reference="courses"
          label="Course Codes"
          filter={companyFilter}
      >
      <AutocompleteArrayInput
        fullWidth
        optionText="code"
        debounce={500}
        filterToQuery={filterToQuery}
        id={'courses'}
      />
    </ReferenceArrayInput>
  );
};
